import React, { useEffect, useState } from 'react';
import './dataTableDollarCharges.scss';
import { DataGrid } from '@mui/x-data-grid';
import { announcementColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, deleteDoc, doc, onSnapshot, query } from "firebase/firestore";
import { db } from '../../firebase'



const DataTable = () => {

  const [ data, setData ] = useState([])

  const [ isLoading, setIsLoading ] = useState(true)


  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }

  useEffect(() => {
   
    
//LISTEN REAL TIME

    const collectionRef = collection(db, "announcement")

    const queryAnnouncement = query(collectionRef)

    const unsub = onSnapshot(queryAnnouncement, (snapShot) => {

      let list = [];

      snapShot.docs.forEach((doc) => {

        list.push({ id: doc.id, ...doc.data()})

      })

      setData(list)

      setIsLoading(false)

    }, 
      (error) => {
        console.log(error)
      }
    );

    return () => {
      unsub();
    }

//END LISTEN REAL TIME    

  },[])


    

  const actionColumn = [

    { field: 'action', headerName: 'Action', width: 180, 
    
            renderCell:(params) => {
                return(
                    <div className='cellAction'>
                      
                        <Link to={`/announcement/edit/${params.row.id}`} style={{textDecoration:"none"}}>
                        <div className="viewbutton">Edit Announcement</div>
                     </Link>
                       
                    </div>
                )
            }
    }
      
  ]  

  return (
    <div className="datatable">
      <div className='datatableTitle'>
        Announcement
        {/* <div></div> */}
      
        <Link to="/announcement/new"  style={{textDecoration:"none"}}>
          <div className='link'>
            Add New Announcement
          </div>
        </Link>
      </div>
      {isLoading ? <Spinner/> : 
        <DataGrid
            className="chargesTableGrid"
            rows={data}
            columns={announcementColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[10]}
            checkboxSelection
            sx={{
              '& .bold-header .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 'bold',
                fontSize:18
              },
            }}
        />
    }
    </div>
  )
}

export default DataTable